import { TimetableEvent } from '@dreryk/react-calendar';
import { ContextDialog } from '@dreryk/react-components';

import { AppointmentEventSlotData } from '~libs.shared.appointments-timetable';

import { AppointmentContextDialogTabs } from './tabs/AppointmentContextDialogTabs';
import { AppointmentContextDialogTitle } from './title/AppointmentContextDialogTitle';

type AppointmentContextDialogProps = {
   readonly triggerElement: HTMLDivElement | null;
   readonly event: TimetableEvent<AppointmentEventSlotData>;
   readonly onEventChange: VoidFunction;
};

export const AppointmentContextDialog = (props: AppointmentContextDialogProps): JSX.Element => {
   return (
      <ContextDialog
         title={<AppointmentContextDialogTitle appointmentId={props.event.data.appointmentId} />}
         key={props.event.id}
         testId={'appointment'}
         triggerElement={props.triggerElement}
         defaultShow
      >
         {(hide) => (
            <AppointmentContextDialogTabs
               onClose={hide}
               appointmentId={props.event.data.appointmentId}
               beginDate={props.event.start}
               endDate={props.event.end}
               patient={props.event.data.patient}
               appointmentStatus={props.event.data.status}
               visitStatus={props.event.data.visit?.status}
               practitionerId={props.event.data.practitionerId.asNumber()}
               visitId={props.event.data.visit?.id}
               timeSlotConfirmed={props.event.data.timeSlotConfirmed}
               ownedByCurrentUser={props.event.data.ownedByCurrentPractitioner}
               onEventChange={props.onEventChange}
            />
         )}
      </ContextDialog>
   );
};
